<template>
  <v-layout
    row
    wrap
    class="pa-4"
    align-center
    justify-center
  >
    <v-flex style="max-width:750px">
      <Toggle
        v-model="hostScreen.host_selection"
        title="Host Selection"
        caption="Enable or disable host selection screen"
        @change="_updateData('host_selection', $event)"
      />
      <template v-if="hostScreen.host_selection">
        <v-textarea
          :value="hostScreen.display_text"
          label="Display text"
          rows="1"
          auto-grow
          @change="_updateData('display_text', $event)"
        />
      </template>
      <template v-if="!hostScreen.host_selection">
        <SettingHeader
          class="py-2"
          title="Fallback Notifications"
          caption="Notifications will be sent to the below selected employee, when host selection is disabled"
        />
        <vizmo-autocomplete
          :items="employees"
          :value="hostScreen.default_notification_receiver"
          class="pt-3"
          label="Host"
          placeholder="Type to search Employees"
          @change="_updateData('default_notification_receiver', $event)"
        />
      </template>
    </v-flex>
  </v-layout>
</template>
<script>
import _get from 'lodash/get';
import _cloneDeep from 'lodash/cloneDeep';
import { database } from '@/firebase';

// TODO: register common components globally
import Toggle from '@/components/common/Toggle';
import SettingHeader from '@/components/common/SettingHeader';
import vizmoAutoComplete from '@/components/common/VizmoAutoComplete';

export default {
  name: 'HostName',
  components: {
    Toggle,
    SettingHeader,
    'vizmo-autocomplete': vizmoAutoComplete
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      hostScreen: {},
      employees: [],
      search: ''
    };
  },
  computed: {
    locationId() {
      return _get(this.$store.state.location, 'lid');
    }
  },
  watch: {
    locationId: {
      handler(val) {
        if (val) this.fetchEmployees();
      },
      immediate: true
    },
    data: {
      handler(val) {
        if (!val) return;
        this.hostScreen = _cloneDeep(val);
      },
      immediate: true
    },
    displayText: {
      handler(val) {
        if (!val) return;
        this.hostSelection.display_text = val;
      }
    },
    hostSelection: {
      handler(val) {
        if (!val) return;
        this.$emit('change', val);
      },
      deep: true
    }
  },
  deactivated() {
    const validation = true;
    this.$emit('update', [this.hostScreen, validation]);
  },
  methods: {
    fetchEmployees() {
      const path = `companies/${this.$store.state.profile.cid}/${
        this.locationId
      }/employees`;
      database.ref(path).once('value', employeeSnapshot => {
        if (!employeeSnapshot) return;
        this.componentLoading = false;
        this.employees = this._toArray(employeeSnapshot.val());
      });
    },

    _toArray(obj) {
      if (!obj) return [];
      return Object.keys(obj).map(key => ({
        id: key,
        name: obj[key].name,
        email: obj[key].email,
        phone: obj[key].phone || ''
      }));
    },

    _updateData(key, val) {
      this.hostScreen[key] = val !== undefined ? val : null;
    }
  }
};
</script>
